import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QueryParameterService {
  getQueryParameter(name: string): Observable<string | null> {
    const urlParams = new URLSearchParams(window.location.search);
    return of(urlParams.get(name));
  }
}
